// Generated by purs version 0.15.16
import * as Concur_Core_LiftWidget from "../Concur.Core.LiftWidget/index.js";
import * as Concur_Core_Types from "../Concur.Core.Types/index.js";
import * as Concur_React_DOM from "../Concur.React.DOM/index.js";
import * as Concur_React_Props from "../Concur.React.Props/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Combinators from "../Data.Argonaut.Decode.Combinators/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as $$Error from "../Error/index.js";
import * as Internal_JsonUtil from "../Internal.JsonUtil/index.js";
import * as Translate from "../Translate/index.js";
import * as Widgets_Form_Access from "../Widgets.Form.Access/index.js";
import * as Widgets_Form_Class from "../Widgets.Form.Class/index.js";
import * as Widgets_Form_Dynamic from "../Widgets.Form.Dynamic/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Concur_Core_Types.applicativeWidget);
var setData = /* #__PURE__ */ Widgets_Form_Class.setData(Widgets_Form_Dynamic.dynFormWidget);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "entries";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "id";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "label";
    }
})(Data_Show.showString))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(Widgets_Form_Dynamic.dynWidgetShow))));
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var fieldPaths = /* #__PURE__ */ Widgets_Form_Class.fieldPaths(Widgets_Form_Dynamic.dynFormWidget);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var mapWithIndex = /* #__PURE__ */ Data_FunctorWithIndex.mapWithIndex(Data_FunctorWithIndex.functorWithIndexArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorFn);
var map1 = /* #__PURE__ */ Data_Functor.map(Concur_Core_Types.functorWidget);
var map2 = /* #__PURE__ */ Data_Functor.map(Widgets_Form_Class.fwrFunctor);
var toWidget = /* #__PURE__ */ Widgets_Form_Class.toWidget(Widgets_Form_Dynamic.dynFormWidget);
var getId = /* #__PURE__ */ Widgets_Form_Class.getId(Widgets_Form_Dynamic.dynFormWidget);
var isLeaf = /* #__PURE__ */ Widgets_Form_Class.isLeaf(Widgets_Form_Dynamic.dynFormWidget);
var voidRight = /* #__PURE__ */ Data_Functor.voidRight(Concur_Core_Types.functorWidget);
var text = /* #__PURE__ */ Concur_React_DOM.text(Concur_Core_LiftWidget.liftWidgetWidget);
var multiAlternativeWidget = /* #__PURE__ */ Concur_Core_Types.multiAlternativeWidget(Data_Monoid.monoidArray);
var div = /* #__PURE__ */ Concur_React_DOM.div(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var button = /* #__PURE__ */ Concur_React_DOM.button(multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var voidRight1 = /* #__PURE__ */ Data_Functor.voidRight(Concur_React_Props.functorProps);
var bind = /* #__PURE__ */ Control_Bind.bind(Concur_Core_Types.bindWidget);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var h4$prime = /* #__PURE__ */ Concur_React_DOM["h4$prime"](multiAlternativeWidget)(Concur_Core_Types.shiftMapWidgetWidget);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJsonArray(Data_Argonaut_Encode_Class.encodeJsonJson));
var getData = /* #__PURE__ */ Widgets_Form_Class.getData(Widgets_Form_Dynamic.dynFormWidget);
var map4 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var getFieldOptional$prime = /* #__PURE__ */ Data_Argonaut_Decode_Combinators["getFieldOptional$prime"](Data_Argonaut_Decode_Class.decodeJsonInt);
var eq = /* #__PURE__ */ Data_Eq.eq(Data_Argonaut_Core.eqJson);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(Data_Argonaut_Decode_Class.decodeJsonJson));
var any = /* #__PURE__ */ Data_Foldable.any(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean);
var foldM = /* #__PURE__ */ Data_Foldable.foldM(Data_Foldable.foldableArray)(Data_Either.monadEither);
var ListWidget = function (x) {
    return x;
};
var simpleListWidget = function (v) {
    return {
        id: v.id,
        label: v.label,
        cls: v.cls,
        entries: [  ],
        addBtns: [ {
            label: Translate.lookupTranslation("add"),
            newEntries: function (v1) {
                return pure([ v.template ]);
            }
        } ],
        load: function (fc) {
            return function (json) {
                return setData(fc)(v.template)(json);
            };
        },
        loadExist: function (fc) {
            return function (oldw) {
                return function (json) {
                    return setData(fc)(oldw)(json);
                };
            };
        }
    };
};
var showLW = {
    show: function (v) {
        return show({
            id: v.id,
            label: v.label,
            entries: v.entries
        });
    }
};
var modalListWidget = function (v) {
    return {
        id: v.id,
        label: v.label,
        addBtns: v.addBtns,
        load: v.load,
        loadExist: v.loadExist,
        cls: v.cls,
        entries: [  ]
    };
};
var listFW = {
    getId: function (v) {
        return v.id;
    },
    isLeaf: function (v) {
        return false;
    },
    asField: function (v) {
        return Data_Maybe.Nothing.value;
    },
    fieldPaths: function (fc) {
        return function (v) {
            var entryPaths = function (idx) {
                return function (widget) {
                    var subfc = Widgets_Form_Class.addParentId({
                        parentIds: fc.parentIds,
                        isAutofilling: fc.isAutofilling,
                        autofillArgs: fc.autofillArgs,
                        account: fc.account,
                        doc: fc.doc,
                        access: fc.access,
                        curIndex: idx
                    })(show1(idx));
                    return fieldPaths(subfc)(widget);
                };
            };
            return append([ Widgets_Form_Class.fieldId(fc)(v.id) ])(Data_Array.concat(mapWithIndex(entryPaths)(v.entries)));
        };
    },
    toWidget: function (fc) {
        return function (v) {
            var updateEntry = function (idx) {
                return function (w) {
                    return map(function (v1) {
                        return {
                            addBtns: v.addBtns,
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: v1
                        };
                    })(Data_Maybe.fromMaybe(v.entries))(Data_Array.updateAt(idx)(w)(v.entries));
                };
            };
            var removeEntry = function (idx) {
                return map(function (v1) {
                    return {
                        addBtns: v.addBtns,
                        cls: v.cls,
                        id: v.id,
                        label: v.label,
                        load: v.load,
                        loadExist: v.loadExist,
                        entries: v1
                    };
                })(Data_Maybe.fromMaybe(v.entries))(Data_Array.deleteAt(idx)(v.entries));
            };
            var id = Widgets_Form_Class.fieldId(fc)(v.id);
            var canModify = Widgets_Form_Class.fieldCanUpdate(fc)(v.id);
            var subWidget = function (idx) {
                return function (w) {
                    var subfc = Widgets_Form_Class.addParentId({
                        parentIds: fc.parentIds,
                        isAutofilling: fc.isAutofilling,
                        autofillArgs: fc.autofillArgs,
                        account: fc.account,
                        doc: fc.doc,
                        access: fc.access,
                        curIndex: idx
                    })(show1(idx));
                    var renderEntry = map1(function (v1) {
                        return map2(updateEntry(idx))(v1);
                    })(toWidget(subfc)(w));
                    var v1 = Widgets_Form_Class.fieldAccessLevel(subfc)(getId(w));
                    if (v1 instanceof Widgets_Form_Access.AccessNone && (isLeaf(w) || !Widgets_Form_Class.fieldHasVisibleDescendant(subfc)(getId(w)))) {
                        return voidRight(Widgets_Form_Class.formWidgetState(v))(text(""));
                    };
                    return div([ Concur_React_Props.className("list-entry") ])(append([ renderEntry ])((function () {
                        if (canModify) {
                            return [ button([ voidRight1(Widgets_Form_Class.formWidgetState(removeEntry(idx)))(Concur_React_Props.onClick), Concur_React_Props.className("btn"), Concur_React_Props["_type"]("button") ])([ text(Translate.lookupTranslation("delete")) ]) ];
                        };
                        return [  ];
                    })()));
                };
            };
            var subWidgets = mapWithIndex(subWidget)(v.entries);
            var addButton = function (v1) {
                return bind(button([ Concur_React_Props.className("btn list-add widget-input"), Concur_React_Props.onClick, Concur_React_Props["_type"]("button") ])([ text(v1.label) ]))(function () {
                    return bind(v1.newEntries(fc))(function (ents) {
                        return pure({
                            addBtns: v.addBtns,
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: Data_Array.concat([ v.entries, ents ])
                        });
                    });
                });
            };
            var addButtons = (function () {
                if (canModify) {
                    return div([ Concur_React_Props.className("list-add-buttons btn-group") ])(map3(addButton)(v.addBtns));
                };
                return div([ Concur_React_Props.className("list-add-buttons btn-group") ])([  ]);
            })();
            var html = div([ Concur_React_Props.className(Widgets_Form_Class.fieldClass(v)), Concur_React_Props.key(id) ])([ div([ Concur_React_Props.className("header") ])([ h4$prime([ text(v.label) ]) ]), div([ Concur_React_Props.className("list w-full") ])(subWidgets), map1(Widgets_Form_Class.formWidgetState)(addButtons) ]);
            return map1(function (v1) {
                return map2(ListWidget)(v1);
            })(html);
        };
    },
    getData: function (fc) {
        return function (v) {
            return encodeJson(map3(getData(fc))(v.entries));
        };
    },
    setData: function (fc) {
        return function (v) {
            return function (json) {
                var entryIndex = function (ejson) {
                    return map4(Data_Maybe.fromMaybe(-1 | 0))($$Error["wrapJsonError$prime"](ejson)(bind1(Internal_JsonUtil.assertObject(ejson))(function (v1) {
                        return getFieldOptional$prime(v1)("_index");
                    })));
                };
                var hasExplicitIndex = function (v1) {
                    if (Data_Argonaut_Core.isArray(v1)) {
                        return false;
                    };
                    var v2 = entryIndex(v1);
                    if (v2 instanceof Data_Either.Right) {
                        return v2.value0 >= 0;
                    };
                    if (v2 instanceof Data_Either.Left) {
                        return false;
                    };
                    throw new Error("Failed pattern match at Widgets.Form.List (line 190, column 34 - line 192, column 28): " + [ v2.constructor.name ]);
                };
                var loadEntry = function ($copy_v1) {
                    return function ($copy_v2) {
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v1, v2) {
                            if (eq(v2)(Data_Argonaut_Core.fromArray([  ]))) {
                                $tco_var_v1 = v1;
                                $copy_v2 = Data_Argonaut_Core.jsonEmptyObject;
                                return;
                            };
                            $tco_done = true;
                            return bind1(entryIndex(v2))(function (v3) {
                                var v4 = Data_Array.index(v1)(v3);
                                if (v4 instanceof Data_Maybe.Nothing) {
                                    return bind1(v.load(fc)(v2))(function (entry) {
                                        return pure1(append(v1)([ entry ]));
                                    });
                                };
                                if (v4 instanceof Data_Maybe.Just) {
                                    return bind1(v.loadExist(fc)(v4.value0)(v2))(function (entry) {
                                        var v5 = Data_Array.updateAt(v3)(entry)(v1);
                                        if (v5 instanceof Data_Maybe.Nothing) {
                                            return pure1(append(v1)([ entry ]));
                                        };
                                        if (v5 instanceof Data_Maybe.Just) {
                                            return pure1(v5.value0);
                                        };
                                        throw new Error("Failed pattern match at Widgets.Form.List (line 208, column 21 - line 210, column 49): " + [ v5.constructor.name ]);
                                    });
                                };
                                throw new Error("Failed pattern match at Widgets.Form.List (line 202, column 13 - line 210, column 49): " + [ v4.constructor.name ]);
                            });
                        };
                        while (!$tco_done) {
                            $tco_result = $tco_loop($tco_var_v1, $copy_v2);
                        };
                        return $tco_result;
                    };
                };
                return bind1($$Error["wrapJsonError$prime"](json)(decodeJson(json)))(function (v1) {
                    var initialEntries = (function () {
                        if (fc.isAutofilling) {
                            return v.entries;
                        };
                        var $139 = any(hasExplicitIndex)(v1);
                        if ($139) {
                            return v.entries;
                        };
                        return [  ];
                    })();
                    return bind1(foldM(loadEntry)(initialEntries)(v1))(function (entries) {
                        return new Data_Either.Right({
                            id: v.id,
                            label: v.label,
                            cls: v.cls,
                            addBtns: v.addBtns,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: entries
                        });
                    });
                });
            };
        };
    }
};
export {
    ListWidget,
    simpleListWidget,
    modalListWidget,
    showLW,
    listFW
};
//# sourceMappingURL=index.js.map
